import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { environment } from '../environments/environment';
import { metaReducers } from './main/common/redux/local.storage.sync';
import { generalReducer } from './main/common/redux/general.reducers';
import { GeneralEffects } from './main/common/redux/general.effects';
import { IsLoggedGuard } from './main/common/guards/isLogged.guard';

const appRoutes: Routes = [
    {
        path: 'login',
        loadChildren: () => import('./main/authentication/authentication.module').then(m => m.AuthenticationModule)
    },
    {
        path: 'dashboard',
        loadChildren: () => import('./main/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'customers',
        loadChildren: () => import('./main/customers/customers.module').then(m => m.CustomersModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'branchOffices',
        loadChildren: () => import('./main/branch-offices/branch-offices.module').then(m => m.BranchOfficesModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'products',
        loadChildren: () => import('./main/products/products.module').then(m => m.ProductsModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'users',
        loadChildren: () => import('./main/users/users.module').then(m => m.UsersModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'roles',
        loadChildren: () => import('./main/roles/roles.module').then(m => m.RolesModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'configurations',
        loadChildren: () => import('./main/configurations/configurations.module').then(m => m.ConfigurationsModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full'
    },
    {
        path: 'inventories',
        loadChildren: () => import('./main/inventories/inventories.module').then(m => m.InventoriesModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'proprietors',
        loadChildren: () => import('./main/proprietors/proprietors.module').then(m => m.ProprietorsModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'properties',
        loadChildren: () => import('./main/properties/properties.module').then(m => m.PropertiesModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'units',
        loadChildren: () => import('./main/units/units.module').then(m => m.UnitsModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'contracts',
        loadChildren: () => import('./main/contracts/contracts.module').then(m => m.ContractsModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'payments',
        loadChildren: () => import('./main/payments/payments.module').then(m => m.PaymentsModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'providers',
        loadChildren: () => import('./main/providers/providers.module').then(m => m.ProvidersModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'purchases',
        loadChildren: () => import('./main/purchases/purchases.module').then(m => m.PurchasesModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'remissions',
        loadChildren: () => import('./main/remissions/remissions.module').then(m => m.RemissionsModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'company_annexes',
        loadChildren: () => import('./main/company-annexes/company-annexes.module').then(m => m.AnnexesModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'expenses',
        loadChildren: () => import('./main/expenses/expenses.module').then(m => m.ExpensesModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {
            scrollPositionRestoration: 'enabled',
            relativeLinkResolution: 'legacy'
        }),
        StoreModule.forRoot({ general: generalReducer }, { metaReducers }),
        EffectsModule.forRoot([GeneralEffects]),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: environment.production
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {

}
